import { render, staticRenderFns } from "./RadioCardGroup.vue?vue&type=template&id=2ae05afc&"
import script from "./RadioCardGroup.vue?vue&type=script&lang=js&"
export * from "./RadioCardGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports